import About from "./components/About";
import ContactUs from "./components/ContactUs";
import ErrorModal from "./components/ErrorModal";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Modal from "./components/Modal";
import Services from "./components/Services";
import WhatsApp from "./components/WhatsApp";
import React from "react";

export default function App() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  return (
    <main className="layout">
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} />
      <ErrorModal isError={isError} setIsError={setIsError} />
      <WhatsApp />
      <Home />
      <About />
      <Services />
      <ContactUs setIsOpen={setIsOpen} setIsError={setIsError} />
      <Footer />
    </main>
  );
}
